import { Alert, Divider, Grid, Typography } from "@mui/joy";
import { TextField } from "../../../../shared";
import { Info } from "lucide-react";

export function DateEstimation() {
    return (
        <Grid container spacing={2} mt={0}>
            <Grid xs={12}>
                <Typography level="title-md">Project Preparation Dates</Typography>
                <Typography level="body-sm" sx={{ mb: 1, color: "text.secondary" }}>
                    Key dates for project planning, approvals, and material procurement
                </Typography>
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Inspection Date"}
                    type={"date"}
                    name={"inspectionDate"}
                    helperText={"Scheduled date for property inspection"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Estimate Date"}
                    type={"date"}
                    name={"estimateDate"}
                    helperText={"Date when the project estimate is provided to the customer"}
                />
            </Grid>

            <Grid xs={6}>
                <TextField
                    label={"Permit Submission Date"}
                    type={"date"}
                    name={"permitSubmissionDate"}
                    helperText={"Date when building permits are submitted to local authorities"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Material Purchase Date"}
                    type={"date"}
                    name={"materialPurchaseDate"}
                    helperText={"Date when materials are ordered or purchased"}
                />
            </Grid>
            <Grid xs={12}>
                <Typography level="title-md" sx={{ mt: 2 }}>
                    Project Execution Dates
                </Typography>
                <Typography level="body-sm" sx={{ mb: 1, color: "text.secondary" }}>
                    Timeline for when construction work begins and is expected to be completed
                </Typography>
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Job Start Date"}
                    type={"date"}
                    name={"jobStartDate"}
                    helperText={"Scheduled date when construction work begins"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    label={"Estimated Completion Date"}
                    type={"date"}
                    name={"estimatedEndDate"}
                    helperText={"Expected date when the project will be completed"}
                />
            </Grid>

            <Grid xs={12}>
                <Alert startDecorator={<Info size={16} />} color="warning" variant="soft">
                    These dates can be modified later from individual task settings if needed
                </Alert>
            </Grid>
        </Grid>
    );
}
